var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyLbsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.83351 0.0844727C10.7851 0.0844727 11.6977 0.462482 12.3705 1.13534C13.0434 1.8082 13.4214 2.7208 13.4214 3.67237C13.4214 4.32716 13.251 4.9371 12.937 5.46632H15.2154C16.0675 5.46632 16.7851 6.06729 16.9644 6.8656C18.7674 14.0504 18.8032 14.2387 18.8032 14.4361C18.8032 14.9118 18.6142 15.3681 18.2778 15.7046C17.9414 16.041 17.4851 16.23 17.0093 16.23H2.65772C2.18193 16.23 1.72563 16.041 1.3892 15.7046C1.05277 15.3681 0.86377 14.9118 0.86377 14.4361C0.86377 14.2387 0.899649 14.0504 2.70257 6.8656C2.88196 6.06729 3.59954 5.46632 4.45166 5.46632H6.72998C6.40975 4.92293 6.24239 4.30308 6.24561 3.67237C6.24561 2.7208 6.62362 1.8082 7.29648 1.13534C7.96934 0.462482 8.88194 0.0844727 9.83351 0.0844727ZM9.83351 1.87842C9.35772 1.87842 8.90143 2.06742 8.565 2.40386C8.22856 2.74029 8.03956 3.19658 8.03956 3.67237C8.03956 4.14815 8.22856 4.60445 8.565 4.94088C8.90143 5.27731 9.35772 5.46632 9.83351 5.46632C10.3093 5.46632 10.7656 5.27731 11.102 4.94088C11.4384 4.60445 11.6275 4.14815 11.6275 3.67237C11.6275 3.19658 11.4384 2.74029 11.102 2.40386C10.7656 2.06742 10.3093 1.87842 9.83351 1.87842Z",
    fill: "#686868"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyLbsIcon);
export default __webpack_public_path__ + "static/media/grey_lbs_icon.83fd9a480b3f0457ed19dd8341525994.svg";
export { ForwardRef as ReactComponent };